import React from 'react'
import PropTypes from 'prop-types'

function Tail({ email, mobilePhone }) {
  const hashString = str => {
    const encodedString = require('crypto')
      .createHash('sha256')
      .update(String(str))
      .digest('hex')
    return encodedString
  }

  return (
    <div style={{ display: 'none' }}>
      {mobilePhone !== '' && (
        <img
          src={`//m.t.tailtarget.com/sync/TT-14471-1/${hashString(
            mobilePhone
          )}`}
          alt="Contact Mobile Phone"
        />
      )}
      {email !== '' && (
        <img
          src={`//m.t.tailtarget.com/sync/TT-14471-1/${hashString(email)}`}
          alt="Contact E-mail"
        />
      )}
    </div>
  )
}

Tail.propTypes = {
  email: PropTypes.string.isRequired,
  mobilePhone: PropTypes.string.isRequired,
}

export default Tail
